module.exports = __webpack_public_path__ + "static/track-fdfd2243272beaf86cf43c1c5d82d6fd.png";